import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ConfigLoaderService} from '../config/configloader.service';
import {Observable} from 'rxjs';
import {Onlineuser} from '../models/onlineuser';
import {Eventuserloggedin} from '../models/syncEvents/persistenceEvents/eventuserloggedin';
import {SynchronizationService} from './synchronization.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
  })
export class OnlineuserService {
  private me: Onlineuser;
  private baseURL: string;
  constructor(private http: HttpClient,
    private configServcie: ConfigLoaderService,
    private synchronizationService: SynchronizationService) {
    this.baseURL = `${this.configServcie.settings.pyWallServer.url}`;
  }
  getCurrentUserInformation(): Observable<any>{
    // eslint-disable-next-line max-len
    return this.http.get<any>(this.baseURL+ 'login/myself/').pipe(map(currentUser => this.me = new Onlineuser(currentUser['accountId'], currentUser['displayName'], '', currentUser['avatarUrls']['48x48'])));
  }
  getMe(): Onlineuser{
    return this.me;
  }
  getAvatarUrl(): string{
    return this.me.avatarImage;
  }
  getLocation(){
    return this.me.location;
  }
  setLocation(location: string){
    this.me.location = location;
  }
  getDisplayName(){
    return this.me.displayName;
  }
  setDisplayName(displayName: string){
    this.me.displayName = displayName;
  }
  getInitialLogin(): void{
    this.synchronizationService.sendPersistenceEventNew(new Eventuserloggedin(null,''));
  }

  setNotLoggedInUser(): void {
    this.me = new Onlineuser('77', '77', '', '');
  }
}
